import React, { ReactNode } from "react";

import { Flex, FlexProps } from "@catchoftheday/cg-components";

type ProductPriceItemChildrenProps = {
  children: ReactNode;
} & FlexProps;

export const ProductPriceItemChildren = ({
  children,
  ...props
}: ProductPriceItemChildrenProps) => {
  return (
    <Flex
      flex="1 0 auto"
      justifyContent="center"
      flexDirection="row"
      flexWrap="nowrap"
      fontWeight="semibold"
      lineHeight="1"
      verticalAlign="middle"
      alignItems="initial"
      {...props}
    >
      {children}
    </Flex>
  );
};
